import { render } from "./ChatWithPatientInformation.vue?vue&type=template&id=82e4952e&scoped=true"
import script from "./ChatWithPatientInformation.vue?vue&type=script&lang=js"
export * from "./ChatWithPatientInformation.vue?vue&type=script&lang=js"

import "./ChatWithPatientInformation.vue?vue&type=style&index=0&id=82e4952e&scoped=true&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82e4952e"]])

export default __exports__